import { render, staticRenderFns } from "./App.vue?vue&type=template&id=96137bd0&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=96137bd0&prod&lang=scss"
import style1 from "./App.vue?vue&type=style&index=1&id=96137bd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96137bd0",
  null
  
)

export default component.exports